export const authenticationService = {
  baseURL: 'https://api.auth.cerclex.com',
};

export const IWMService = {
  baseURL: 'https://wasteknot-server1.cerclex.com/',
};

export const auctionService = {
  baseURL: 'https://server-auction.cerclex.com/auction',
};

export const geteWayAuctionServer = {
  baseURL: 'https://server-auction.cerclex.com',
};


export const socketURL = 'https://wasteknot-server1.cerclex.com/';


